import React from 'react';

const SuccessPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/success',
			exact: true,
			component: React.lazy(() => import('./SuccessPage')),
		},
	],
};

export default SuccessPageConfig;
